export const Quiz = {
	Question: 'Question {{currentQuestion}}',
	'Question of': 'Question {{currentQuestion}} of {{totalQuestions}}',
};
